import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import Home from "../pages/Home";
import SalesHome from "../pages/products/sales/Home";
import Legal from "../pages/Legal";
import Services from "../pages/Services";
import Terms from "../pages/terms";
import Faq from "../pages/Faq";
import BuildSyncHome from "../pages/products/buildsync/Home";
import HotelHome from "../pages/products/hotel/Home";

const publicRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/services",
    component: <Services />,
  },
  {
    path: "/about-us",
    component: <AboutUs />,
  },
  {
    path: "/contact-us",
    component: <ContactUs />,
  },
  {
    path: "/faq",
    component: <Faq />,
  },
  {
    path: "/legal",
    component: <Legal />,
  },
  {
    path: "/terms",
    component: <Terms />,
  },
  {
    path: "/sales",
    component: <SalesHome />,
  },
  {
    path: "/buildsync",
    component: <BuildSyncHome />,
  },
  {
    path: "/hotel",
    component: <HotelHome />,
  },
];

export { publicRoutes };
